import { h } from 'preact';

export interface SelectGamePageProps {
    onBack: () => void;
    onStartGame: (opts: {cols: number}) => void;
}

export function SelectGamePage({ onBack, onStartGame } : SelectGamePageProps) {
    
    return (
    <div class="select-game-page">
        <div class="title-section">
          <a class="back-button" onClick={()=>onBack()}>&#8249;</a>
            <span>Vowels</span>
        </div>
        <div class="content-section">
          <div class="content-wrapper">
            <div class="select-game-menu">
            <h2>Select Game Type</h2>
            <div class="menu-options">
                <a onClick={()=>onStartGame({cols: 3})}>Quick Game</a>
                <a onClick={()=>onStartGame({cols: 4})}>Medium Game</a>
                <a onClick={()=>onStartGame({cols: 5})}>Large Game</a>
            </div>
          </div>
          </div>
        </div>
    </div>
    )
}


